import React, { Component } from 'react'
import { graphql, compose, withApollo } from 'react-apollo'
import { CardHeader, CardBody, Button, Row, Col, Label, Form, Input, FormGroup, FormFeedback } from 'reactstrap'
import CreatableSelect from './CreatableSelect'
import WpsParametersForm from './WpsParametersForm'
import WpsBaseMaterialsForm from './WpsBaseMaterialsForm'
import DropzoneComponent from 'react-dropzone-component'
import { UploadFiles, acceptedFiles, acceptedFilesIcons, UploadOrReplaceFiles } from '../../utils/uploadFiles'
import { WpsDictionariesFetch, createOrUpdateWpsMutation, WpsStandardizationsAndMaterialsFetch, ParseWpsPdfMutation } from './mutations'
import { StandardsDimensionsWeldersQuery } from '../Welders/mutations'
import { destroyAttachmentsMutation } from '../Projects/mutations'
import PropTypes from 'prop-types'
import _ from 'lodash'
import BlockWithLoader from '../Support/BlockWithLoader'
import heatInputValue from './helpers/heatInputValue'
import GasTypeModal from '../Dictionary/GasTypeModal'
// import {withGaEvent} from '../Support/GoogleAnalytics'
import { getUserPermissions } from '../../utils/userPermissions'
import { API_BASE_URL } from '../../utils/apiConfig'
import Comments from '../Comments/Comments'
import ImageCrop from '../Support/ImageCrop'
import PdfPreview, { loadPdfPages } from './PdfPreview'

export const emptyDictionaries = {
  type_of_current_polarities: [],
  welding_processes: [],
  welding_positions: [],
  welding_details: [],
  preparations: [],
  metal_transfers: [],
  weld_types: [],
  joint_types: [],
  product_types: [],
}

class WpsForm extends Component {

  constructor(props) {
    super(props)
    this.state = {
      jointDesignSaveFunc: null,
      weldingSequenceSaveFunc: null,
      validation_errors: {},
      validation_errors_msg: null,
      gas_type_modal_field: null,
      form_values: {},
      files: [],
      filesSelectedToRemove: [],
      dictionaries: { ...emptyDictionaries },
      standard_id: null,
      wps_id: null,
      welderCertificationStandards: [],
      pqr_wpqr_wpqt: [],
      backing: [],
      gouging: [],
      bevel: [],
      welder_certification_standards: [],
      project_ids: [],
      welding_detail_ids: [],
      joint_type_ids: [],
      weld_type_ids: [],
      preparation_names: [],
      metal_transfer_names: [],
      shield_gas_ids: [],
      backing_gas_ids: [],
      pdf_parsing: false,
      pdf_parse_error: null,
      pdf_pages: [],
      pdf_preview_visible: false,
      pdf_input_key: Date.now(),
      joint_design_preview: null,
      welding_sequence_preview: null,
      parameters_attributes: [{
        run: '',
        current: [0, 0],
        voltage: [0, 0],
        wire_feed: [0, 0],
        travel_speed: [0, 0],
        filler_material_operate: '',
        filler_material_size: '',
        heat_input: [0, 0],
        filler_material: {},
        welding_process: {},
        welding_position_ids: [],
        type_of_current_polarity: {},
        _destroy: null
      }],
      base_materials_attributes: [{ product_type: {}, thickness: ['0', '0'], throat_thickness: ['0', '0'], diameter: ['0', '0'], base_material: {}, _destroy: null }]
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleSelectStandardValueChange = this.handleSelectStandardValueChange.bind(this)
    this.handleWpsParametersValueChange = this.handleWpsParametersValueChange.bind(this)
    this.handleWpsBaseMaterialsValueChange = this.handleWpsBaseMaterialsValueChange.bind(this)
    this.setGasType = this.setGasType.bind(this)
    this.handlePdfUpload = this.handlePdfUpload.bind(this)

    this.djsConfig = {
      addRemoveLinks: true,
      autoProcessQueue: false,
      acceptedFiles: acceptedFiles,
      maxFiles: 1,
    }
    this.componentConfig = {
      iconFiletypes: acceptedFilesIcons,
      showFiletypeIcon: true,
      postUrl: 'no-url',
    }
    this.dropzone = null
  }

  static propTypes = {
    client: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    wpsData: PropTypes.object,
    createOrUpdateWps: PropTypes.func.isRequired,
    destroyAttachmentsMutation: PropTypes.func.isRequired
  }

  componentWillMount() {
    this.fetchWelderCertificationStandards()
    if (this.props.wpsData) {
      this.fetchDictionariesData(Number(this.props.wpsData.standard.id))

      let wps = this.props.wpsData
      this.setState({
        wps_id: wps.id,
        form_values: _.pick(wps, 'no', 'manufacturer', 'actual', 'release_date', 'rev_no', 'interpass_temp', 'preheat_temp',
          'additional_info', 'shield_gas_flow_rate', 'backing_gas_flow_rate', 'post_heating',
          'preheat_maintenenace_temp', 'post_weld_heat_operate'),
        standard_id: wps.standard ? Number(wps.standard.id) : null,
        pqr_wpqr_wpqt: wps.pqr_wpqr_wpqt.map((x) => {
          return { name: x }
        }),
        backing: wps.backing.map((x) => {
          return { name: x }
        }),
        gouging: wps.backing.map((x) => {
          return { name: x }
        }),
        bevel: wps.bevel.map((x) => {
          return { name: x }
        }),
        welder_certification_standards: wps.welder_certification_standards || [],
        project_ids: (wps.project_ids || []).map(id => {
          const project = (this.props.data.projects_depth1 || []).find(p => String(p.id) === String(id))
          return project || { id: String(id) }
        }),
        welding_detail_ids: wps.welding_detail_ids,
        joint_type_ids: wps.joint_type_ids,
        weld_type_ids: wps.weld_type_ids,
        shield_gas_ids: wps.shield_gas_ids,
        backing_gas_ids: wps.backing_gas_ids,
        preparation_names: wps.preparations && wps.preparations.map(o => o.name),
        metal_transfer_names: wps.metal_transfers && wps.metal_transfers.map(o => o.name),
        parameters_attributes: wps.parameters.map(a => Object.assign({}, a)),
        base_materials_attributes: wps.used_base_materials.map(a => Object.assign({}, a))
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.wpsData && nextProps.data.loading === false) {
      this.fetchDictionariesData(Number(nextProps.data.wps_standardizations[0].id))
    }
    // projects_depth1 just loaded — re-resolve project names if needed
    if (this.props.data.projects_depth1 !== nextProps.data.projects_depth1 && this.state.project_ids.length > 0) {
      this.setState({
        project_ids: this.state.project_ids.map(p => {
          if (p.name) return p
          const found = (nextProps.data.projects_depth1 || []).find(proj => String(proj.id) === String(p.id))
          return found || p
        })
      })
    }
  }

  fetchDictionariesData(standard_id, pdfWpsData) {
    this.props.client.query({
      query: WpsDictionariesFetch,
      fetchPolicy: 'network-only',
      variables: { standard_id: standard_id }
    }).then(({ data }) => {
      let preparedData = {}
      Object.keys(emptyDictionaries).forEach(key => {
        preparedData[key] = data.wps_dictionaries[key].map(o => ({ ...o, label: this.prepareLabel(o) }))
      })
      if (pdfWpsData) {
        const mergeIntoDictionary = (existing, incoming) => {
          const ids = new Set(existing.map(o => o.id))
          const extra = (incoming || []).filter(o => o && o.id && !ids.has(o.id)).map(o => ({ ...o, label: o.name }))
          return [...existing, ...extra]
        }
        preparedData.weld_types = mergeIntoDictionary(preparedData.weld_types, pdfWpsData.weld_type_ids)
        preparedData.joint_types = mergeIntoDictionary(preparedData.joint_types, pdfWpsData.joint_type_ids)
      }
      this.setState({ dictionaries: preparedData, standard_id: standard_id })
    })
  }

  fetchWelderCertificationStandards() {
    this.props.client.query({
      query: StandardsDimensionsWeldersQuery,
      fetchPolicy: 'network-only',
      variables: { filters: { permission_key: 'core.people.welder', active: 'true' } }
    }).then(({ data }) => {
      this.setState({
        welderCertificationStandards: data.welder_certificate_standardizations
      })
    })
  }

  handlePdfUpload(e) {
    const file = e.target.files[0]
    if (!file) return
    this.setState({ pdf_parsing: true, pdf_parse_error: null, pdf_pages: [], pdf_preview_visible: true, files: [...this.state.files, file] })
    const reader = new FileReader()
    reader.onload = () => {
      const base64 = reader.result.split(',')[1]
      loadPdfPages(reader.result).then(pages => {
        this.setState({ pdf_pages: pages })
      })
      this.props.client.mutate({
        mutation: ParseWpsPdfMutation,
        variables: { pdf_base64: base64 }
      }).then(({ data }) => {
        const { wps_data: wps_data_raw, errors } = data.parseWpsPdf
        const wps_data = typeof wps_data_raw === 'string' ? JSON.parse(wps_data_raw) : wps_data_raw
        if (errors) {
          this.setState({ pdf_parsing: false, pdf_parse_error: errors })
          return
        }
        if (wps_data.standard_id) {
          this.fetchDictionariesData(Number(wps_data.standard_id), wps_data)
        }
        const base64ToFile = (b64, filename) => {
          const binary = atob(b64)
          const bytes = new Uint8Array(binary.length)
          for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i)
          return new File([bytes], filename, { type: 'image/png' })
        }

        const newFiles = [...this.state.files]

        const mergeIntoDictionary = (existing, incoming) => {
          const ids = new Set(existing.map(o => o.id))
          const extra = (incoming || []).filter(o => o && o.id && !ids.has(o.id)).map(o => ({ ...o, label: o.name }))
          return [...existing, ...extra]
        }
        this.setState({
          dictionaries: {
            ...this.state.dictionaries,
            weld_types: mergeIntoDictionary(this.state.dictionaries.weld_types, wps_data.weld_type_ids),
            joint_types: mergeIntoDictionary(this.state.dictionaries.joint_types, wps_data.joint_type_ids),
          },
          pdf_parsing: false,
          standard_id: wps_data.standard_id ? Number(wps_data.standard_id) : this.state.standard_id,
          form_values: {
            no: wps_data.no || '',
            rev_no: wps_data.rev_no || '',
            release_date: wps_data.release_date || '',
            manufacturer: wps_data.manufacturer || '',
            preheat_temp: wps_data.preheat_temp || '',
            interpass_temp: wps_data.interpass_temp || '',
            post_heating: wps_data.post_heating || '',
            shield_gas_flow_rate: wps_data.shield_gas_flow_rate || '',
            backing_gas_flow_rate: wps_data.backing_gas_flow_rate || '',
            additional_info: wps_data.additional_info || ''
          },
          pqr_wpqr_wpqt: (wps_data.pqr_wpqr_wpqt || []).map(x => ({ name: x })),
          backing: (wps_data.backing || []).map(x => ({ name: x })),
          gouging: (wps_data.gouging || []).map(x => ({ name: x })),
          bevel: (wps_data.bevel || []).map(x => ({ name: x })),
          shield_gas_ids: wps_data.shield_gas_ids || [],
          backing_gas_ids: wps_data.backing_gas_ids || [],
          weld_type_ids: (wps_data.weld_type_ids || []).map(o => ({ ...o, label: o.name })),
          joint_type_ids: (wps_data.joint_type_ids || []).map(o => ({ ...o, label: o.name })),
          preparation_names: wps_data.preparation_names || [],
          parameters_attributes: (wps_data.parameters_attributes || []).length > 0
            ? wps_data.parameters_attributes
            : this.state.parameters_attributes,
          base_materials_attributes: (wps_data.used_base_materials_attributes || []).length > 0
            ? wps_data.used_base_materials_attributes
            : this.state.base_materials_attributes,
          files: newFiles,
          joint_design_preview: wps_data.joint_design_png ? `data:image/png;base64,${wps_data.joint_design_png}` : null,
          welding_sequence_preview: wps_data.welding_sequence_png ? `data:image/png;base64,${wps_data.welding_sequence_png}` : null,
        })
      }).catch(err => {
        this.setState({ pdf_parsing: false, pdf_parse_error: err.message })
      })
    }
    reader.readAsDataURL(file)
  }

  handleSubmit(e) {
    e.preventDefault()
    if (!this.state.standard_id) {
      return this.setState({ validation_errors_msg: ['Please select Standardization'] }, () => { window.scrollTo(0, 0) })
    }
    this.props.createOrUpdateWps({
      variables: {
        wps: {
          id: this.state.wps_id,
          standard_id: this.state.standard_id,
          ...this.state.form_values,
          pqr_wpqr_wpqt: this.getSelectValues(this.state.pqr_wpqr_wpqt, 'name'),
          backing: this.getSelectValues(this.state.backing, 'name'),
          gouging: this.getSelectValues(this.state.gouging, 'name'),
          bevel: this.getSelectValues(this.state.bevel, 'name'),
          welder_certification_standards: this.getSelectValues(this.state.welder_certification_standards),
          welding_detail_ids: this.getSelectValues(this.state.welding_detail_ids),
          joint_type_ids: this.getSelectValues(this.state.joint_type_ids),
          weld_type_ids: this.getSelectValues(this.state.weld_type_ids),
          preparation_names: this.getSelectValues(this.state.preparation_names, 'name'),
          metal_transfer_names: this.getSelectValues(this.state.metal_transfer_names, 'name'),
          shield_gas_ids: this.getSelectValues(this.state.shield_gas_ids),
          backing_gas_ids: this.getSelectValues(this.state.backing_gas_ids),
          project_ids: (this.state.project_ids || []).map(p => String(p.id || p)),
          parameters_attributes: this.prepareParametersAttributes(),
          used_base_materials_attributes: this.prepareBaseMaterialsAttributes()
        }
      }
    }).then(({ data: { createOrUpdateWps } }) => {
      if (createOrUpdateWps.errors) {
        // withGaEvent({category: 'Wps', action: 'error save'}) // GA EVENT
        this.setState({ validation_errors: JSON.parse(createOrUpdateWps.errors), validation_errors_msg: createOrUpdateWps.error_messages },
          () => { window.scrollTo(0, 0) })
      } else {
        const objectId = Number(createOrUpdateWps.wps.id)
        // ADD FILE
        if (this.state.files.length > 0) {
          UploadFiles(objectId, 'WlWelds::Wps', this.state.files)
        }

        // REMOVE FILES
        if (this.state.filesSelectedToRemove.length > 0) {
          this.props.destroyAttachmentsMutation({
            variables: {
              attachment_id: this.state.filesSelectedToRemove, attachable_id: objectId, attachable_type: 'WlWelds::Wps'
            }
          })
        }
        // withGaEvent({category: 'Wps', action: 'save'}) // GA EVENT
        this.setState({
          wps_id: objectId,
          jointDesignSaveFunc: (file) => UploadOrReplaceFiles(objectId, 'WlWelds::Wps', [file], {}, 'WlWelds::Attachments::JointDesign'),
          weldingSequenceSaveFunc: (file) => UploadOrReplaceFiles(objectId, 'WlWelds::Wps', [file], {}, 'WlWelds::Attachments::WeldingSequence'),
        }, () => this.props.history.goBack())
      }
    })
  }

  handleFileAdded(file) {
    this.setState({ files: [...this.state.files, file] })
  }

  handleFileRemoved(file) {
    let newFilesList = this.state.files.filter(function (item) {
      return (item !== file)
    })

    this.setState({ files: newFilesList })
  }

  onCheckboxBtnClick(selected) {
    const index = this.state.filesSelectedToRemove.indexOf(Number(selected))
    if (index < 0) {
      this.state.filesSelectedToRemove.push(Number(selected))
    } else {
      this.setState({ filesSelectedToRemove: this.state.filesSelectedToRemove.splice(index, 1) })
    }
    this.setState({ filesSelectedToRemove: this.state.filesSelectedToRemove })
  }

  handleWpsParametersValueChange(values) {
    this.setState({ parameters_attributes: values })
  }

  handleWpsBaseMaterialsValueChange(values) {
    this.setState({ base_materials_attributes: values })
  }

  prepareParametersAttributes() {
    let preparedValues = this.state.parameters_attributes.map((record) => {
      console.log('record.welding_process:', record.welding_process);
      return {
        id: record.id,
        run: record.run && record.run.value ? record.run.value : record.run,
        current: record.current,
        voltage: record.voltage,
        wire_feed: record.wire_feed,
        travel_speed: record.travel_speed,
        heat_input: heatInputValue(record.voltage, record.current, record.travel_speed, record.welding_process),
        filler_material_id: record.filler_material && Number(record.filler_material.id),
        welding_process_id: record.welding_process && Number(record.welding_process.id),
        welding_position_ids: this.getSelectValues(record.welding_position_ids),
        type_of_current_polarity_id: record.type_of_current_polarity && Number(record.type_of_current_polarity.id),
        filler_material_operate: record.filler_material_operate,
        filler_material_size: record.filler_material_size,
        _destroy: record._destroy
      }
    })
    return preparedValues
  }

  parseValue(value) {
    if (typeof value === 'string') {
      const normalized = value.toLowerCase();
      if (normalized === 'infinity' || normalized === '∞') {
        return Infinity;
      }
    }
    return parseFloat(value) || 0.0;
  }

  arrayToString(array) {
    return array.map(value => this.parseValue(value)).map(String);
  }

  prepareBaseMaterialsAttributes() {
    let preparedValues = this.state.base_materials_attributes.map((record) => {
      let wpsBaseMaterialValues = {
        id: record.id,
        drawing_symbol: record.drawing_symbol,
        product_type_id: record.product_type && Number(record.product_type.id),
        base_material_id: record.base_material && Number(record.base_material.id),
        thickness: record.thickness && this.arrayToString(record.thickness),
        throat_thickness: record.throat_thickness && this.arrayToString(record.throat_thickness),
        diameter: record.diameter && this.arrayToString(record.diameter),
        _destroy: record._destroy
      }
      return wpsBaseMaterialValues
    })
    return preparedValues
  }

  getSelectValues(selectData, valueKeyName = 'id') {
    return (selectData || []).map(data => {
      return valueKeyName === 'name' ? data[valueKeyName] || data : Number(data[valueKeyName]) || Number(data)
    })
  }

  handleSelectStandardValueChange(value) {
    if (value && Number(value.id) !== this.state.standard_id) {
      this.fetchDictionariesData(Number(value.id))
      // TODO: clear related form fields
    } else {
      this.setState({ dictionaries: emptyDictionaries, standard_id: null })
    }
  }

  handleSelectValueChange(inputName) {
    let self = this

    function updateSelectValue(values) {
      self.setState({ [inputName]: values })
    }
    return updateSelectValue
  }

  prepareLabel(o) {
    return `${o.name}${o.description ? `-${o.description}` : ''}`
  }

  setGasType(gas_type) {
    let gas_field_name = this.state.gas_type_modal_field
    let gas_feild_value = [...this.state[gas_field_name], { id: gas_type.id, label: this.prepareLabel(gas_type) }]
    this.setState({ [gas_field_name]: gas_feild_value, gas_type_modal_field: null })
  }

  render() {
    const eventHandlers = {
      init: dz => this.dropzone = dz,
      addedfile: this.handleFileAdded.bind(this),
      removedfile: this.handleFileRemoved.bind(this)
    }

    if (this.props.data.error) {
      return (<div>An unexpected error occurred</div>)
    }

    return (
      <BlockWithLoader loading={this.props.data.loading}>
        {typeof (this.state.gas_type_modal_field) === 'string' &&
          <GasTypeModal
            onCancel={() => this.setState({ gas_type_modal_field: null })}
            afterSubmit={this.setGasType}
          />}

        {!this.props.wpsData &&
          <CardHeader>
            <b>New WPS</b>
          </CardHeader>
        }
        <CardBody>
          {this.state.validation_errors_msg &&
            <h4 className="errors-heading">{this.state.validation_errors_msg.join(', ')}</h4>
          }
          <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
            <div style={{ flex: 1, minWidth: 0, marginRight: this.state.pdf_pages.length > 0 && this.state.pdf_preview_visible ? 'calc(50% + 32px)' : '0' }}>

          <Form id="wps-form" className="form-select FormClassLabel" onSubmit={this.handleSubmit}>
            <Row>
              <Col xs="12">
                {getUserPermissions('wl_welds.import_wps_pdf.import_wps_pdf') && <div style={{ border: '2px dashed #007bff', borderRadius: '6px', padding: '16px', marginBottom: '20px', backgroundColor: '#f8f9ff' }}>
                  <h6 style={{ marginBottom: '8px' }}>📄 Import from PDF</h6>
                  <input
                    key={this.state.pdf_input_key}
                    type="file"
                    accept="application/pdf"
                    onChange={this.handlePdfUpload}
                    disabled={this.state.pdf_parsing}
                    style={{ marginBottom: '8px' }}
                  />
                  {this.state.pdf_parsing && <div style={{ color: '#007bff' }}>⏳ Parsing PDF with AI, please wait...</div>}
                  {this.state.pdf_parse_error && <div style={{ color: '#dc3545' }}>❌ {this.state.pdf_parse_error}</div>}
                  {!this.state.pdf_parsing && !this.state.pdf_parse_error && this.state.pdf_pages.length === 0 && <small style={{ color: '#6c757d' }}>Upload a WPS PDF to pre-fill the form. You can review and edit all fields before saving.</small>}
                  {this.state.pdf_pages.length > 0 && (
                    <button
                      type="button"
                      onClick={() => this.setState({ pdf_preview_visible: !this.state.pdf_preview_visible })}
                      style={{ marginTop: '4px', display: 'inline-flex', alignItems: 'center', gap: '6px', background: this.state.pdf_preview_visible ? '#343a40' : '#007bff', border: 'none', color: '#fff', borderRadius: '4px', padding: '6px 14px', cursor: 'pointer', fontSize: '13px', fontWeight: '500' }}
                    >
                      {this.state.pdf_preview_visible ? '◀ Hide PDF' : '▶ Show PDF'}
                    </button>
                  )}
                </div>}
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="3">
                <Label>Manufacturer</Label>
                <Input id="manufacturer-wps-form"
                  name="manufacturer"
                  value={this.state.form_values.manufacturer || ''}
                  onChange={(e) => this.setState({
                    form_values: { ...this.state.form_values, manufacturer: e.target.value }
                  })}
                />
              </Col>
              <Col xs="12" sm="3">
                <CreatableSelect label="PQR, WPQR, WPQT No" id="pqr-wpqr-wpqt-wps-form"
                  options={[]}
                  valueKey="name"
                  value={this.state.pqr_wpqr_wpqt}
                  multi={true}
                  creatable={true}
                  valueChangeFunction={this.handleSelectValueChange('pqr_wpqr_wpqt')} />
              </Col>
              <Col xs="12" sm="3">
                <CreatableSelect label="Welder certification standards" id="welder-certification-standards-wps-form"
                  options={this.state.welderCertificationStandards}
                  valueKey="id"
                  value={this.state.welder_certification_standards}
                  multi={true}
                  creatable={false}
                  valueChangeFunction={this.handleSelectValueChange('welder_certification_standards')} />
              </Col>
              <Col xs="12" sm="3">
                <CreatableSelect label="Assign to projects" id="project-ids-wps-form"
                  options={(this.props.data.projects_depth1 || [])}
                  valueKey="id"
                  labelKey="name"
                  value={this.state.project_ids}
                  multi={true}
                  creatable={false}
                  valueChangeFunction={this.handleSelectValueChange('project_ids')} />
              </Col>
            </Row>
            <br />
            <Row>
              <Col xs="12" sm="3">
                <Label>No</Label>
                <Input id="no-wps-form"
                  name="no"
                  required
                  value={this.state.form_values.no || ''}
                  onChange={(e) => this.setState({ form_values: { ...this.state.form_values, no: e.target.value } })}
                />
              </Col>
              <Col xs="12" sm="3">
                <Label>Rev No</Label>
                <Input id="rev-no-wps-form"
                  name="rev_no"
                  required
                  value={this.state.form_values.rev_no || ''}
                  onChange={(e) => this.setState({
                    form_values: { ...this.state.form_values, rev_no: e.target.value }
                  })}
                />
              </Col>
              <Col xs="12" sm="3">
                <Label>Release date</Label>
                <Input id="date-wps-form"
                  name="release_date"
                  type="date"
                  required
                  value={this.state.form_values.release_date || ''}
                  onChange={(e) => this.setState({
                    form_values: { ...this.state.form_values, release_date: e.target.value }
                  })}
                />
              </Col>
              <Col xs="12" sm="3">
                <FormGroup check inline style={{ marginTop: '25px' }}>
                  <Label check>
                    <Input type="checkbox"
                      name="actual"
                      checked={this.state.form_values.actual || false}
                      onChange={(e) => this.setState({
                        form_values: { ...this.state.form_values, actual: e.target.checked }
                      })}
                    /> Actual
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col xs="12" sm="4">
                <CreatableSelect
                  label="Standardization"
                  id="select-standard-wps-form"
                  options={this.props.data.wps_standardizations}
                  valueKey="id"
                  value={this.state.standard_id}
                  multi={false}
                  creatable={false}
                  valueChangeFunction={this.handleSelectStandardValueChange} />
                <FormFeedback>{this.state.validation_errors.standard}</FormFeedback>
              </Col>
              <Col xs="12" sm="4">
                <CreatableSelect label="Joint types" id="joint-types-wps-form"
                  options={this.state.dictionaries.joint_types}
                  valueKey="id"
                  labelKey="label"
                  value={this.state.joint_type_ids}
                  multi={true}
                  creatable={false}
                  valueChangeFunction={this.handleSelectValueChange('joint_type_ids')} />
              </Col>
              <Col xs="12" sm="4">
                <CreatableSelect label="Weld types" id="weld-types-wps-form"
                  options={this.state.dictionaries.weld_types}
                  valueKey="id"
                  labelKey="label"
                  value={this.state.weld_type_ids}
                  multi={true}
                  creatable={false}
                  valueChangeFunction={this.handleSelectValueChange('weld_type_ids')} />
              </Col>
            </Row>
            <br />
            <Row>
              <Col xs="12" sm="4">
                <CreatableSelect label="Preparation and cleaning" id="preparation-wps-form"
                  options={this.state.dictionaries.preparations}
                  valueKey="name"
                  labelKey="label"
                  placeholder="Select or type..."
                  value={this.state.preparation_names}
                  multi={true}
                  creatable={true}
                  valueChangeFunction={this.handleSelectValueChange('preparation_names')} />
              </Col>
              <Col xs="12" sm="4">
                <CreatableSelect label="Welding details" id="welding-details-wps-form"
                  options={this.state.dictionaries.welding_details}
                  valueKey="id"
                  labelKey="label"
                  value={this.state.welding_detail_ids}
                  multi={true}
                  creatable={false}
                  valueChangeFunction={this.handleSelectValueChange('welding_detail_ids')} />
              </Col>
              <Col xs="12" sm="4">
                <CreatableSelect label="Metal transfer" id="metal-transfer-wps-form"
                  options={this.state.dictionaries.metal_transfers}
                  valueKey="name"
                  labelKey="label"
                  placeholder="Select or type..."
                  value={this.state.metal_transfer_names}
                  multi={true}
                  creatable={true}
                  valueChangeFunction={this.handleSelectValueChange('metal_transfer_names')} />
              </Col>
            </Row>
            <br />
            <Row>
              <Col xs="12" sm="4">
                <CreatableSelect id="shield-gas-wps-form"
                  options={(this.props.data.gas_types || []).map(o => ({ id: o.id, label: this.prepareLabel(o) }))}
                  valueKey="id"
                  labelKey="label"
                  value={this.state.shield_gas_ids}
                  multi={true}
                  creatable={true}
                  label={<label className="BtnClassLabel">{'Shield gas '}
                    <Button color="primary" size="sm" className="BtnLabel"
                      onClick={() => this.setState({ gas_type_modal_field: 'shield_gas_ids' })}>Add new
                    </Button>
                  </label>}
                  valueChangeFunction={this.handleSelectValueChange('shield_gas_ids')} />
              </Col>
              <Col xs="12" sm="4">
                <Label>Shield gas flow rate [l/min]</Label>
                <Input id="shield_gas_flow_rate-wps-form"
                  name="shield_gas_flow_rate"
                  value={this.state.form_values.shield_gas_flow_rate || ''}
                  onChange={(e) => this.setState({
                    form_values: { ...this.state.form_values, shield_gas_flow_rate: e.target.value }
                  })}
                />
              </Col>
              <Col xs="12" sm="4">
                <CreatableSelect label="Gouging" id="gouging-wps-form"
                  options={[]}
                  valueKey="name"
                  value={this.state.gouging}
                  multi={true}
                  creatable={true}
                  valueChangeFunction={this.handleSelectValueChange('gouging')} />
              </Col>
            </Row>
            <br />
            <Row>
              <Col xs="12" sm="4">
                <CreatableSelect id="backing_gas-gas-wps-form"
                  options={(this.props.data.gas_types || []).map(o => ({ id: o.id, label: this.prepareLabel(o) }))}
                  valueKey="id"
                  labelKey="label"
                  value={this.state.backing_gas_ids}
                  multi={true}
                  creatable={false}
                  label={<label className="BtnClassLabel">{'Backing gas '}
                    <Button color="primary" size="sm" className="BtnLabel"
                      onClick={() => this.setState({ gas_type_modal_field: 'backing_gas_ids' })}>Add new
                    </Button>
                  </label>}
                  valueChangeFunction={this.handleSelectValueChange('backing_gas_ids')} />
              </Col>
              <Col xs="12" sm="4">
                <Label>Backing gas flow rate [l/min]</Label>
                <Input id="backing_gas_flow_rate-wps-form"
                  name="backing_gas_flow_rate"
                  value={this.state.form_values.backing_gas_flow_rate || ''}
                  onChange={(e) => this.setState({
                    form_values: { ...this.state.form_values, backing_gas_flow_rate: e.target.value }
                  })}
                />
              </Col>
              <Col xs="12" sm="4">
                <CreatableSelect label="Backing" id="backing-wps-form"
                  options={[]}
                  valueKey="name"
                  value={this.state.backing}
                  multi={true}
                  creatable={true}
                  valueChangeFunction={this.handleSelectValueChange('backing')} />
              </Col>
            </Row>
            <br />
            <Row>
              <Col xs="12" sm="4">
                <CreatableSelect label="Bevel" id="bevel-wps-form"
                  options={[]}
                  valueKey="name"
                  value={this.state.bevel}
                  multi={true}
                  creatable={true}
                  valueChangeFunction={this.handleSelectValueChange('bevel')} />
              </Col>
              <Col xs="12" sm="4">
                <Label>Preheat temperature</Label>
                <Input id="preheat_temp-wps-form"
                  name="preheat_temp"
                  label="Preheat temperature [oC]"
                  value={this.state.form_values.preheat_temp || ''}
                  onChange={(e) => this.setState({
                    form_values: { ...this.state.form_values, preheat_temp: e.target.value }
                  })}
                />
              </Col>
              <Col xs="12" sm="4">
                <Label>Interpass temperature [oC]</Label>
                <Input id="interpass_temp-wps-form"
                  name="interpass_temp"
                  value={this.state.form_values.interpass_temp || ''}
                  onChange={(e) => this.setState({
                    form_values: { ...this.state.form_values, interpass_temp: e.target.value }
                  })}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col xs="12" sm="4">
                <Label>Post heating</Label>
                <Input id="post_heating-wps-form"
                  name="post_heating"
                  value={this.state.form_values.post_heating || ''}
                  onChange={(e) => this.setState({
                    form_values: { ...this.state.form_values, post_heating: e.target.value }
                  })}
                />
              </Col>
              <Col xs="12" sm="4">
                <Label>Preheat maintenenace temperature [oC]</Label>
                <Input id="preheat_maintenenace_temp-wps-form"
                  name="preheat_maintenenace_temp"
                  value={this.state.form_values.preheat_maintenenace_temp || ''}
                  onChange={(e) => this.setState({
                    form_values: { ...this.state.form_values, preheat_maintenenace_temp: e.target.value }
                  })}
                />
              </Col>
              <Col xs="12" sm="4">
                <Label>Post weld heat operate</Label>
                <Input id="post_weld_heat_operate-wps-form"
                  name="post_weld_heat_operate"
                  value={this.state.form_values.post_weld_heat_operate || ''}
                  onChange={(e) => this.setState({
                    form_values: { ...this.state.form_values, post_weld_heat_operate: e.target.value }
                  })}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col xs="12" sm="12">
                <Label>Additional Info</Label>
                <Input id="additional-wps-form"
                  name="additional_info"
                  type="textarea"
                  placeholder="e.g.: Weaving(maximum width of run), Oscillation: amplitude, frequency, dwell time,
                                      Pulse welding details, Distance contact tube/work piece, Plasma welding details, Torch angle"
                  value={this.state.form_values.additional_info || ''}
                  onChange={(e) => this.setState({
                    form_values: { ...this.state.form_values, additional_info: e.target.value }
                  })}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col xs="12" sm="12">
                {getUserPermissions('core.comments.index') &&
                  <Comments commentableId={this.state.wps_id} commentableType='WlWelds::Wps' />}
              </Col>
            </Row>
            <Row>
              <Col md="6" style={{ minWidth: '520px', minHeight: '400px' }}>
                <h6>Joint design</h6>
                <ImageCrop
                  imageUrl={this.state.joint_design_preview || (this.props.wpsData && this.props.wpsData.joint_design && API_BASE_URL + this.props.wpsData.joint_design.url)}
                  imageSaveName='joint_design'
                  editorHeight={300}
                  editorWidth={500}
                  saveImageFunction={this.state.jointDesignSaveFunc}
                />
              </Col>
              <Col md="6" style={{ minWidth: '520px', minHeight: '400px' }}>
                <h6>Welding sequence</h6>
                <ImageCrop
                  imageUrl={this.state.welding_sequence_preview || (this.props.wpsData && this.props.wpsData.welding_sequence && API_BASE_URL + this.props.wpsData.welding_sequence.url)}
                  imageSaveName='welding_sequence'
                  editorHeight={300}
                  editorWidth={500}
                  saveImageFunction={this.state.weldingSequenceSaveFunc}
                />
              </Col>
            </Row>

            <DropzoneComponent config={this.componentConfig} eventHandlers={eventHandlers} djsConfig={this.djsConfig} />
            {this.props.wpsData && this.props.wpsData.attachments &&
              <aside>
                <br />
                <h6>Attached files:</h6>
                <ol className="attachment-list">
                  {this.props.wpsData.attachments.map(f =>
                    <Row key={f.id}>
                      <Col md="12">
                        <div className="checkbox">
                          <label>
                            <input type="checkbox"
                              onClick={() => this.onCheckboxBtnClick(f.id)}
                              active={this.state.filesSelectedToRemove.includes(f.id).toString()}
                            /> &nbsp;
                            <span>
                              <a href={API_BASE_URL + f.url} target='blank'>
                                {f.data_file_name}
                              </a>
                            </span>
                          </label>
                        </div>
                      </Col>
                    </Row>)}
                </ol>
              </aside>
            }

            <hr />
            <div>
              <WpsBaseMaterialsForm
                value={this.state.base_materials_attributes}
                validation_errors={this.state.validation_errors.used_base_materials || []}
                valueChangeFunction={this.handleWpsBaseMaterialsValueChange}
                base_material_dict={this.props.data.base_materials}
                product_type_dict={this.state.dictionaries.product_types} />
            </div>
            <hr />
            <div>
              <WpsParametersForm
                value={this.state.parameters_attributes}
                validation_errors={this.state.validation_errors.parameters || []}
                valueChangeFunction={this.handleWpsParametersValueChange}
                welding_process_dict={this.state.dictionaries.welding_processes}
                welding_position_dict={this.state.dictionaries.welding_positions}
                type_of_current_polarity_dict={this.state.dictionaries.type_of_current_polarities}
                filler_material_dict={this.props.data.filler_materials} />
            </div>
            <hr />
            <div>
              {(this.state.wps_id ? getUserPermissions('wl_welds.wps.update') : getUserPermissions('wl_welds.wps.create')) &&
                <Button id="save-wps-btn" type="submit" color="primary" className="float-right">
                  <i className="fa fa-plus" /> Save
                </Button>}
            </div>
            <br /><br />
          </Form>
            </div>
            {this.state.pdf_pages.length > 0 && this.state.pdf_preview_visible && (
              <div style={{ position: 'fixed', top: '55px', left: 'calc(200px + 50vw - 100px)', width: 'calc(50vw - 116px)', maxHeight: 'calc(100vh - 71px)', overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '6px', background: '#fff', zIndex: 100 }}>
                <PdfPreview pages={this.state.pdf_pages} />
              </div>
            )}
          </div>
        </CardBody>
      </BlockWithLoader>
    )
  }
}

const WpsFormWithMutation = compose(
  graphql(WpsStandardizationsAndMaterialsFetch,
    { options: { fetchPolicy: 'network-only' } }
  ),
  graphql(createOrUpdateWpsMutation, { name: 'createOrUpdateWps' }),
  graphql(destroyAttachmentsMutation, { name: 'destroyAttachmentsMutation' }),
  graphql(ParseWpsPdfMutation, { name: 'parseWpsPdf' })
)(WpsForm)

export default withApollo(WpsFormWithMutation)



// WEBPACK FOOTER //
// ./src/components/Wps/WpsForm.js